import script from "./LiveRoom.vue?vue&type=script&setup=true&lang=js"
export * from "./LiveRoom.vue?vue&type=script&setup=true&lang=js"

import "./LiveRoom.vue?vue&type=style&index=0&id=20d2e8bd&scoped=true&lang=css"

import exportComponent from "/home/tamo/projects/wedio/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20d2e8bd"]])

export default __exports__